import {
  Dialog,
  Icon,
  IconButton,
  InputAdornment,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import LabelInput from 'app/componentV4/Labels/LabelInput'
import { CLOSE, SECONDARY } from 'app/constants/button'
import clsx from 'clsx'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import * as Yup from 'yup'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      overflowX: 'auto',
    },
  },
  input: {
    '&.MuiOutlinedInput-root': {
      height: '48px !important',
    },
  },
  button: {
    '& .button-close': {
      textTransform: 'none',
      padding: '0.75rem 1.25rem',
      color: theme.colors['grey-200'],
      border: '1px solid',
      borderColor: theme.colors['grey-200'],
      borderRadius: '4px',
      backgroundColor: 'transparent !important',
      '&:hover': {
        color: theme.colors['grey-400'],
        borderColor: theme.colors['grey-400'],
      },
      '&:action': {
        color: theme.colors['grey-300'],
        borderColor: theme.colors['grey-300'],
      },
    },
    '& .button-submit': {
      backgroundColor: theme.colors['primary'],
      color: theme.palette.light.main,
      textTransform: 'none',
      padding: '0.75rem 1.25rem',
      '&:hover': {
        backgroundColor: theme.colors['primary-500'],
      },
      '&:action': {
        backgroundColor: theme.colors['primary'],
      },
    },
    '& .MuiButton-contained.Mui-disabled': {
      backgroundColor: `${theme.colors['grey-100']} !important`,
    },
  },
}))

export default (props) => {
  const { open, onClose, onSubmit, isLoading, name } = props
  const classes = useStyles()
  const [isShowPassword, setIsShowPassword] = useState(false)

  const { formatMessage } = useIntl()
  return (
    <Dialog open={open} onClose={onClose} className={classes.root}>
      <div className="mt-3 text-primary">
        <div className="flex justify-between">
          <div className="text-blue-950 text-lg font-bold leading-6 p-5 px-10">
            <FormattedMessage id="transfer.dialog.title" />
          </div>
          <div className="px-5">
            <IconButton
              aria-owns="close button"
              aria-haspopup="true"
              className="p-4"
              disabled={isLoading}
              onClick={onClose}
            >
              <Icon color="action" className="text-24 text-blue-950 font-600">
                close
              </Icon>
            </IconButton>
          </div>
        </div>

        <div className="my-5 space-y-3 text-left px-10 pb-5">
          <Typography className=" text-14 text-primary">
            <FormattedMessage id="transfer.dialog.content.start" />
            <label className="font-bold px-2">{name}</label>
          </Typography>
          <ul className="text-left list-disc list-inside space-y-3 text-14 text-primary pl-5 ">
            <li>
              <FormattedMessage id="transfer.dialog.list1" />
            </li>
            <li>
              <FormattedMessage id="transfer.dialog.list2" />
            </li>
            <li>
              <FormattedMessage id="transfer.dialog.list3" />
            </li>
          </ul>
          <Formik
            enableReinitialize={true}
            initialValues={{
              password: '',
            }}
            validationSchema={Yup.object({
              password: Yup.string().required(
                formatMessage({
                  id: 'composeDialog.field.required',
                }),
              ),
            })}
            onSubmit={(values, { setSubmitting, setFieldError }) => {
              onSubmit(values.password, setFieldError)
              setSubmitting(false)
            }}
          >
            {({
              dirty,
              values,
              errors,
              isSubmitting,
              isValid,
              handleBlur,
              handleChange,
            }) => {
              return (
                <Form>
                  <div className="py-5">
                    <LabelInput
                      label={formatMessage({
                        id: 'transfer.password',
                      })}
                      required
                    >
                      <SimpleInput
                        className={classes.input}
                        id="transfer-dialog-input-password"
                        name="password"
                        type={isShowPassword ? 'text' : 'password'}
                        placeholder={formatMessage({
                          id: 'login.textField.placeHolder.password',
                        })}
                        value={values.password}
                        size="medium"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              tabIndex={-1}
                              aria-label="toggle new password visibility"
                              onClick={() => setIsShowPassword(!isShowPassword)}
                            >
                              {isShowPassword ? (
                                <Visibility
                                  fontSize="small"
                                  className="text-grey-200"
                                />
                              ) : (
                                <VisibilityOff
                                  fontSize="small"
                                  className="text-grey-200"
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </LabelInput>
                  </div>

                  <div
                    className={clsx(
                      classes.button,
                      'flex justify-center space-x-5 mt-10',
                    )}
                  >
                    <OutlinedButtons
                      tabIndex={-1}
                      id="close-confirm-password-dialog"
                      type="button"
                      color={CLOSE}
                      disabled={isSubmitting || isLoading}
                      onClick={onClose}
                    >
                      <FormattedMessage id="text.close" />
                    </OutlinedButtons>
                    <ContainedButton
                      id="transfer-account-btn"
                      color={SECONDARY}
                      isLoading={isSubmitting || isLoading}
                      type="submit"
                      disabled={isSubmitting || !isValid || !dirty || isLoading}
                    >
                      <FormattedMessage id="transfer.dialog.btn" />
                    </ContainedButton>
                  </div>
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </Dialog>
  )
}
